export default __webpack_public_path__ + "static/media/STRANGE KATASTROPHE.e0ce8a4f.jpg";